// CSS carousel
'use client';
import cn from 'classnames';
import { ReactNode } from 'react';

import './PlanCarousel.style.scss';

type PlanCarouselProps = {
  className?: string;
  children: ReactNode;
};

function PlanCarousel(props: PlanCarouselProps) {
  const { className = '', children } = props;

  return <div className={cn('PlanCarousel', className)}>{children}</div>;
}

export default PlanCarousel;
